<template>
  <div class="TrainingVideo">
    <!-- <a-form layout="inline" :model="seekData" class="ant-advanced-search-form">
      <a-form-item label="视频名称">
        <a-input
          v-model="seekData.drillVideoName"
          placeholder="请输入视频名称"
        />
      </a-form-item>
      <a-form-item label="视频日期">
        <a-range-picker
          v-model="seekData.time"
          valueFormat="YYYY-MM-DD"
          :placeholder="['开始时间', '结束时间']"
        />
      </a-form-item>
      <a-form-item>
        <a-button class="mr10" type="primary" icon="search" @click="doSeek">
          查询
        </a-button>
        <a-button @click="removeSeek" icon="reload"> 重置 </a-button>
      </a-form-item>
    </a-form> -->

    <!-- el版 -->
    <el-form :inline="true" :model="seekData" class="ant-advanced-search-form">
      <el-form-item label="视频名称">
        <el-input v-model="seekData.drillVideoName" placeholder="请输入视频名称"></el-input>
      </el-form-item>

      <el-form-item label="视频日期">
        <el-date-picker v-model="seekData.time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="doSeek" icon="el-icon-search">查询</el-button>
        <el-button icon="el-icon-refresh" type="" @click="removeSeek">重置</el-button>
      </el-form-item>
    </el-form>

    <div v-if="list.length" class="videoCont">
      <div class="videoItem" v-for="(item, index) in list" :key="index">
        <div class="videoCover" @click="playVideo(item)">
          <video :src="item.drillVideoPath" :width="300" :height="150"></video>
          <div class="videoMask">
            <a-icon type="play-circle" theme="filled" style="font-size: 28px; color: #fff" />
            <div class="mt5">{{ formatLength(item.videoLength) }}</div>
          </div>
        </div>
        <div class="mt10 elpss">
          {{ item.drillVideoName }}-{{ videoTypeObj[item.type] }}
        </div>
        <div class="info">
          <div class="flxL">
            <a-avatar size="small" :src="item.createByHeadImageUrl"></a-avatar>
            <span>{{ item.createBy }}</span>
          </div>
          <div class="flxR txt-gray size12">
            {{ moment(item.createTime).format("yyyy-MM-DD") }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="list.length" class="flxEnd">
      <!-- <a-pagination
        show-quick-jumper
        :page-size="doSeekData.pageSize"
        :current="doSeekData.pageNum"
        :total="total"
        @change="changePage"
      /> -->
      <pagination :total="total" :page.sync="doSeekData.pageNum" :limit.sync="doSeekData.pageSize"
        @pagination="getList" />
    </div>
    <a-empty v-else :image="simpleImage" />

    <VideoPlay :fileUrl="video_url" :coverUrl="coverUrl" :show="video_show" @change="closeVideo" />
  </div>
</template>
<script>
import moment from "moment";
import { Empty } from "ant-design-vue";
import VideoPlay from "@/components/training/videoPlay";
import * as API_Member from "@/api/train/member";
export default {
  inject: ["getId"],
  computed: {
    id() {
      return this.getId();
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      seekData: {
        drillVideoName: null,
        time: [],
      },
      doSeekData: {
        drillVideoName: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      },
      total: 10,
      list: [],
      video_url: "",
      video_show: false,
      videoTypeObj: {
        1: "比赛",
        2: "训练",
        3: "分析",
      },
    };
  },
  components: {
    VideoPlay,
  },
  computed: {
    moment: () => moment,
    formatLength() {
      return (num) => {
        const min = Math.floor(num / 1000 / 60);
        const sec = Math.floor(num / 1000 - 60 * min);
        return `${min.toString().padStart(2, "0")}:${sec
          .toString()
          .padStart(2, "0")}`;
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 切换分页
    changePage(e) {
      console.log("切换分页", e);
      this.doSeekData.pageNum = e;
      this.getList();
    },

    // 点击搜索
    doSeek() {
      console.log("1--", this.id, this.seekData);
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.doSeekData[key] = this.seekData[key];
        }
      });
      if (this.seekData.time.length > 0) {
        this.doSeekData.startTime = moment(this.seekData.time[0]).valueOf();
        this.doSeekData.endTime = moment(this.seekData.time[1]).valueOf();
      }

      this.doSeekData.pageNum = 1;
      this.getList();
    },
    // 重置
    removeSeek() {
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.seekData[key] = null;
        } else {
          this.seekData[key] = [];
        }
      });
      Object.keys(this.doSeekData).forEach((key) => {
        if (key != "time") {
          this.doSeekData[key] = null;
        } else {
          this.doSeekData[key] = [];
        }
      });
      this.doSeekData.pageNum = 1;
      this.doSeekData.pageSize = 10;
      this.getList();
      // this.$refs.form.resetFields()
    },
    getList() {
      let params = {
        memberId: this.id || this.$route.query.id,
        ...this.doSeekData,
      };
      API_Member.getSportVideo(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
      });
    },
    playVideo(e) {
      let jsone = JSON.parse(JSON.stringify(e));
      if (jsone.videoId) {
        API_Member.getPlayUrls(jsone.videoId)
          .then((res) => {
            if (res.data) {
              this.video_show = true;
              this.video_url = res.data.playInfoList[0].playURL;
              this.coverUrl = res.data.videoBase.coverURL;
            } else {
              this.video_show = true;
              this.video_url = jsone.drillVideoPath;
              this.coverUrl = "";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.video_show = true;
        this.video_url = jsone.drillVideoPath;
        this.coverUrl = "";
      }
    },
    closeVideo() {
      this.video_show = false;
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";

.TrainingVideo {
  .videoCont {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .videoItem {
    width: 320px;
    margin: 0 20px 20px 0;
    color: #ffffff;
    cursor: pointer;

    .cover {
      width: 320px;
      height: 180px;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 5px;
      color: #999;

      span {
        margin-right: 5px;
      }

      span:last-child {
        margin-right: 0;
      }
    }

    .ant-avatar {
      margin-right: 4px;
    }

    video {
      width: 100%;
      height: 100%;
    }
  }

  .videoCover {
    position: relative;
    width: 320px;
    height: 180px;
    border-radius: 4px;
    overflow: hidden;
  }

  .videoMask {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 320px;
    height: 180px;
    padding-top: 20px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
<style lang="less">
.videoItem {
  .ant-image {
    width: 100%;
    height: 100%;
  }

  .ant-image-img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
    background-color: #eee;
  }
}
</style>
